// Definición de defaults

export const defaultTipoConsecutivo: TipoConsecutivoProps = {
    idTipoConsecutivo:  0,
    descripcion:        '',
    activo:             false,
}

// Creación de interfaces

export interface TipoConsecutivoProps   {
    idTipoConsecutivo:  number;
    descripcion:        string;
    activo:             boolean;
}